import React from "react";
import {
  isInternalStaff,
  getStaffInitials,
  getStaffTypeMeta,
} from "../utils/staff.helpers";
import { EntityCard } from "../../../shared/components/patterns";

export default function StaffCard({
  member,
  onClick,
  onEdit,
  onArchive,
  canManageStaff = false,
}) {
  const internal = isInternalStaff(member);
  const type = getStaffTypeMeta(internal ? "interno" : "esterno");

  return (
    <EntityCard
      title={member.name}
      subtitle={member.role}
      initials={getStaffInitials(member.name)}
      status={{
        label: member.status === "inactive" ? "Disattivato" : "Attivo",
        tone: member.status === "inactive" ? "neutral" : "approved",
      }}
      meta={[
        { label: "Tipo", value: type.label },
        { label: "Email", value: member.email },
        { label: "Telefono", value: member.phone },
        {
          label: "Competenze",
          value:
            Array.isArray(member.skills) && member.skills.length
              ? member.skills.join(", ")
              : "N/D",
        },
      ]}
      actions={[
        !internal && canManageStaff
          ? {
              id: "edit",
              label: "Modifica membro team",
              iconKey: "actions.edit",
              onClick: () => onEdit?.(member),
            }
          : null,
        canManageStaff
          ? {
              id: member.status === "inactive" ? "reactivate" : "deactivate",
              label:
                member.status === "inactive"
                  ? "Riattiva membro team"
                  : "Disattiva membro team",
              iconKey:
                member.status === "inactive"
                  ? "actions.reset"
                  : "actions.delete",
              tone: member.status === "inactive" ? "default" : "danger",
              onClick: () =>
                onArchive?.(
                  member,
                  member.status === "inactive" ? "reactivate" : "deactivate",
                ),
            }
          : null,
        canManageStaff && !internal && member.status === "inactive"
          ? {
              id: "delete-permanently",
              label: "Elimina definitivamente membro team",
              iconKey: "actions.delete",
              tone: "danger",
              onClick: () => onArchive?.(member, "delete"),
            }
          : null,
      ].filter(Boolean)}
      onClick={() => onClick(member)}
    />
  );
}
